export default __webpack_public_path__ + "static/media/Muli-Bold.24ed2213.ttf";